import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

/**
* Class Sort
*
*/
export class Sort extends ActiveModel {
/**
  * field
  * поле
  */
  @ActiveField('')
  field: string = ''

  /**
  * direction
  *   */
  @ActiveField(SortDirection.DESC)
  direction: SortDirection = SortDirection.DESC

  // get sortString() {
  //   if (!this.field) {
  //     return ''
  //   }

  //   return [this.field, this.direction].join(' ')
  // }

  // set sortString(value: string) {
  //   if (!value) {
  //     return
  //   }
  //   const [field, direction] = value.split(' ')
  //   this.field = field || ''
  //   this.direction = (direction || SortDirection.ASC) as SortDirection
  // }
}
